var map = {
	"./company.js": 916,
	"./index.js": 414,
	"./messages.js": 917,
	"./notifications.js": 918,
	"./products.js": 919,
	"./tasks.js": 920,
	"./test.js": 921,
	"./user.js": 922
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1404;


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules nonrecursive \.js$
// module id = 1404
// module chunks = 94